import React from 'react';
import { Checkbox } from '@trustpilot/businessapp-patternlibrary';

interface ProductCheckboxProps {
  includeProductReviews: boolean;
  onChange: () => void;
}

const ProductReviewsCheckbox = ({
  includeProductReviews,
  onChange,
}: ProductCheckboxProps) => {
  return (
    <Checkbox checked={includeProductReviews} onChange={onChange}>
      Include product reviews
    </Checkbox>
  );
};

export default ProductReviewsCheckbox;
